import { render, staticRenderFns } from "./MiniWizardItemsContent.vue?vue&type=template&id=25407f30"
import script from "./MiniWizardItemsContent.vue?vue&type=script&lang=js"
export * from "./MiniWizardItemsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports